import { Form, Grid, Theme, Viewport } from '@livecontrol/core-ui';
import cx from 'classnames';
import { FormikProvider } from 'formik';
import _ from 'lodash';
import React from 'react';
import type { SimpleInterpolation } from 'styled-components';
import styled, { css } from 'styled-components';
import type { Props } from './form';
import { useForm } from './form';

const Separator = styled.div<{ direction: 'bottom' | 'left' | 'right' | 'top' }>`
  ${({ direction }): SimpleInterpolation | undefined =>
    css`
      border-${direction}: 1px solid var(--white40);
    `}
    display: grid;
`;

export const OperatorNotes = (props: Props): React.ReactElement => {
  const { formik } = useForm(props);
  const viewport = Theme.useViewport();

  return (
  <FormikProvider value={formik}>
    <Form className='mt-24px pt-8px pl-24px'>
      <Grid
      gridTemplateColumns={
        viewport === Viewport.XL || viewport === Viewport.LG ? 'repeat(2, 1fr)' : '1fr'
      }>
        <Grid className='pr-lg-16px'>
          <Grid.Item className='d-flex flex-column'>
            <div className='position-relative'>
              <h1 className='text-white font-size-18px'>Support Notes</h1>
            </div>
            {/* <Form.Attribute label='Email Address' value={event.operator_notes ?? ''} /> */}
            <Form.Group
              name='supportNotes'
              label='Editable internal notes'
              className='d-flex flex-column h-100'
              controlProps={{
                as: 'textarea',
                className: 'h-100',
                disabled: true,
                style: { backgroundColor: 'var(--white10)' }
              }}
            />
          </Grid.Item>
          <Grid.Item className='d-flex flex-column'>
            <h1 className='text-white font-size-18px'>Permanent Operator Notes</h1>
            <Form.Group
              name='permanentNotes'
              label='Editable permanent operator notes'
              className='d-flex flex-column h-100'
              controlProps={{
                as: 'textarea',
                className: 'h-100',
                disabled: true,
                style: { backgroundColor: 'var(--white10)' }
              }}
            />
          </Grid.Item>
        </Grid>
        <Separator className={cx('pl-lg-16px', !(viewport === Viewport.XL || viewport === Viewport.LG) && 'mt-12px pt-12px')} direction={
          viewport === Viewport.XL || viewport === Viewport.LG ? 'left' : 'top'
        }>
          <Grid.Item className='d-flex flex-column'>
            <h1 className='text-white font-size-18px'>Operator Notes</h1>
            <Form.Group
              name='operatorNotes'
              label='Notes from client'
              error={false}
              className='d-flex flex-column h-100'
              controlProps={{
                as: 'textarea',
                className: 'h-100',
                disabled: true,
                style: { backgroundColor: 'var(--white10)' }
              }}
            />
          </Grid.Item>
        </Separator>
      </Grid>
    </Form>
  </FormikProvider>
  );
};
